import { Link } from 'react-router-dom';
import './Home.css';
import heroLogoImage from '../assets/images/bca-ventures-logo.png';
import capitalGrowthImage from '../assets/images/home-capital-growth.jpg';
import partnershipsImage from '../assets/images/home-partnerships.jpg';
import technologyDataImage from '../assets/images/home-technology-data.jpg';
import productDesignImage from '../assets/images/home-product-design.jpg';
import howItWorksImage from '../assets/images/home-how-it-works.jpg';
import ctaBgImage from '../assets/images/home-cta-bg.jpg';
import cityscapeImage from '../assets/images/home-cityscape.png';
import stackAdvisoryImage from '../assets/images/stack-advisory.jpg';
import stackAlliancesImage from '../assets/images/stack-alliances.jpg';
import stackTechnologyImage from '../assets/images/stack-technology.jpg';
import stackDesignImage from '../assets/images/stack-design.jpg';
import stackAppsImage from '../assets/images/stack-apps.jpg';

const categories = [
  {
    title: 'AI Digital Personas & Campaigns',
    desc: 'Engage next-generation influencers tailored to your brand’s personality, audience, and values. From lifelike avatars with distinct personalities to custom AI software, we blend creativity and technology to redefine how brands show up in the digital world.',
    image: capitalGrowthImage,
  },
  {
    title: 'AI Digital Content Development',
    desc: 'Partner with our team to create AI-powered content that expands your online presence and engages your audience—from reels, still images, and posts to short- and long-form videos.',
    image: partnershipsImage,
  },
  {
    title: 'Technology & AI Content Strategy',
    desc: 'We leverage various AI models and technology to create digital content targeted to resonate with sophisticated online users.',
    image: technologyDataImage,
  },
  {
    title: 'Ideation, Design & Execution',
    desc: 'We partner with clients to shape strategy, generate ideas, and create. Original content sharpens your message, builds thought leadership, delivers personalized insights, and reflects your organization’s values. It also engages your audience while keeping your brand voice consistent.',
    image: productDesignImage,
  },
];

const stackPanels = [
  {
    label: 'AI Digital Personas & Campaigns',
    short: 'Personas',
    tagline: 'Engage next-generation influencers tailored to your brand’s personality, audience, and values.',
    image: stackAdvisoryImage,
    theme: 'advisory',
  },
  {
    label: 'AI Digital Content Development',
    short: 'Content',
    tagline: 'Partner with our team to create AI-powered content that expands your online presence',
    image: stackAlliancesImage,
    theme: 'alliances',
  },
  {
    label: 'Technology & AI Content Strategy',
    short: 'Strategy',
    tagline: 'We leverage various AI models and technology to create digital content',
    image: stackTechnologyImage,
    theme: 'technology',
  },
  {
    label: 'Ideation, Design & Execution',
    short: 'Design',
    tagline: 'We partner with clients to shape strategy, generate ideas, and create.',
    image: stackDesignImage,
    theme: 'design',
  },
  {
    label: 'Next Gen App Development',
    short: 'Apps',
    tagline: 'Because 75% of consumers judge companies by their app design, your app needs a compelling visual identity and clear, relevant messaging.',
    image: stackAppsImage,
    theme: 'apps',
  },
];

const enquireHighlights = [
  {
    title: 'One Accountable Team',
    desc: 'Advisors and technologists work side by side, so nothing gets lost between strategy and execution.',
  },
  {
    title: 'Seasoned and Leading Edge Experience',
    desc: 'You’ll work with a tested team experience with technology, AI and digital marketing.',
  },
  {
    title: 'Built for Long Run Success',
    desc: 'We iterate through the product development process, providing constant improvement, and delivering a seamless user experience for our products and our clients.',
  },
];

function Home() {
  return (
    <>
      <div className="hero-reveal-wrap">
        <section className="hero">
          <div className="container hero-wrap">
            <img
              className="hero-logo-banner"
              src={heroLogoImage}
              alt="BCA Ventures"
            />
          </div>
          <div className="hero-scroll" aria-hidden="true">
            <span className="hero-scroll-label">Scroll</span>
            <span className="hero-scroll-line" />
          </div>
        </section>

        <section className="section intro">
          <div className="intro-cols">
            <div className="intro-text">
              <span className="eyebrow">At the Intersection of AI &amp; Digital Content Design &amp; Creation</span>
              <h1 className="intro-heading">
                <span className="intro-heading-line">AI and Technology</span>
                <span className="script">Digital Content Professionals</span>
              </h1>
              <p className="section-lead">
                BCA Ventures is a research-driven digital design studio
                focused on thoughtful execution to help reach audience segments
                through our work with AI personas. Through rigorous, ongoing
                research, our team creates engaging digital content,
                experiences, and content that resonates with audiences.
              </p>
              <p className="section-lead">
                BCA Ventures unites experienced product technologists and
                digital marketers in one integrated team. Engage us for a
                technology deep dive, strategic assessment, hands-on product
                development, or to leverage our existing technology products
                and digital content.
              </p>
              <div className="intro-actions">
                <Link to="/contact-us" className="btn btn-dark">
                  Get in Touch
                </Link>
                <Link to="/about-us" className="btn btn-ghost">
                  Learn About Us
                </Link>
              </div>
            </div>

            <div className="intro-art">
              <svg viewBox="0 0 420 460" className="intro-sketch" aria-hidden="true">
                <g stroke="#152238" strokeLinecap="round" strokeLinejoin="round" fill="none">
                  <g transform="rotate(-6 210 230)">
                    <rect x="70" y="40" width="280" height="380" rx="18" strokeWidth="2.5" />
                    <rect x="72" y="42" width="276" height="376" rx="17" strokeWidth="1.2" opacity="0.55" />

                    <line x1="100" y1="92" x2="250" y2="92" strokeWidth="2.5" />
                    <line x1="100" y1="93" x2="250" y2="93" strokeWidth="1" opacity="0.5" />
                    <line x1="100" y1="116" x2="210" y2="116" strokeWidth="2.5" />
                    <line x1="100" y1="117" x2="210" y2="117" strokeWidth="1" opacity="0.5" />

                    <rect x="108" y="300" width="42" height="90" rx="4" strokeWidth="2.5" />
                    <rect x="184" y="255" width="42" height="135" rx="4" strokeWidth="2.5" />
                    <rect x="260" y="200" width="42" height="190" rx="4" strokeWidth="2.5" />
                    <rect x="109" y="301" width="40" height="88" rx="4" strokeWidth="1" opacity="0.45" />
                    <rect x="185" y="256" width="40" height="133" rx="4" strokeWidth="1" opacity="0.45" />
                    <rect x="261" y="201" width="40" height="188" rx="4" strokeWidth="1" opacity="0.45" />

                    <polyline points="112,290 194,235 270,170 318,130" strokeWidth="2.5" />
                    <polyline points="113,291 195,236 271,171 319,131" strokeWidth="1" opacity="0.5" />
                    <polyline points="296,124 318,130 310,152" strokeWidth="2.5" />

                    <circle cx="112" cy="290" r="6" strokeWidth="2.5" />
                    <circle cx="194" cy="235" r="6" strokeWidth="2.5" />
                    <circle cx="270" cy="170" r="6" strokeWidth="2.5" />
                  </g>
                </g>
              </svg>
            </div>
          </div>
        </section>
      </div>

      <section className="cityscape-banner">
        <img src={cityscapeImage} alt="" className="cityscape-banner-img" />
      </section>

      <section className="section reframe" id="why-bca-ventures">
        <div className="container why-split">
          <div className="why-intro">
            <span className="eyebrow">Why BCA Ventures</span>
            <h2 className="why-statement">
              We are AI-First Digital Marketing Strategists, executing
              intelligent systems, campaigns, and applications for our internal
              operations as well as on behalf of clients.
            </h2>
          </div>

          <ul className="why-list">
            <li className="why-item">
              <div className="why-item-head">
                <span className="why-item-bullet" aria-hidden="true" />
                <h3>AI-Powered Digital Personas</h3>
              </div>
              <p>
                Our team designs and produces AI-powered digital personas for
                brands. From custom digital avatars and AI influencers to
                digital twins and campaign-ready virtual models, we help brands
                build scalable digital presence across advertising, social media
                and brand activations. Our approach combines creative direction,
                technology and production to deliver high impact digital
                campaigns and assets.
              </p>
            </li>
            <li className="why-item">
              <div className="why-item-head">
                <span className="why-item-bullet" aria-hidden="true" />
                <h3>Mobile &amp; Web Applications</h3>
              </div>
              <p>
                We develop both mobile and web applications for our clients as
                well as market our own applications across the web, Apple iOS
                and Android platforms.
              </p>
            </li>
          </ul>
        </div>
      </section>

      {categories.map((category, index) => (
        <section className="section category" key={category.title}>
          <div
            className={`container category-cols${index % 2 === 1 ? ' is-reverse' : ''}`}
          >
            <div className="category-photo">
              <div
                className="category-photo-img"
                style={{ backgroundImage: `url(${category.image})` }}
              />
            </div>
            <div>
              {category.eyebrow && (
                <span className="eyebrow">{category.eyebrow}</span>
              )}
              <h2 className="section-heading">{category.title}</h2>
              <p>{category.desc}</p>
            </div>
          </div>
        </section>
      ))}

      <div className="stack-wrap">
        {stackPanels.map((panel, index) => (
          <section className="stack-panel" key={panel.label}>
            <div
              className={`stack-tab stack-theme-${panel.theme}`}
              style={{
                width: `${100 / stackPanels.length}%`,
                marginLeft: `${(index * 100) / stackPanels.length}%`,
              }}
            >
              <span className="stack-tab-full">{panel.label}</span>
              <span className="stack-tab-short" aria-hidden="true">
                {panel.short}
              </span>
            </div>
            <div className={`stack-body stack-theme-${panel.theme}`}>
              <p className="stack-tagline">{panel.tagline}</p>
              <div
                className="stack-image"
                style={{ backgroundImage: `url(${panel.image})` }}
              />
            </div>
          </section>
        ))}
        <section className="stack-panel stack-panel-logo" aria-label="BCA Ventures">
          <img src={heroLogoImage} alt="BCA Ventures" className="stack-logo" />
        </section>
      </div>

      <section className="section how" id="how-it-works">
        <div className="container how-split">
          <div>
            <span className="eyebrow">How it works</span>
            <h2 className="how-lead">From first call to lasting partnership</h2>
            <p>
              We keep engagements small and senior. A dedicated team of
              advisors and technologists works alongside you from the first
              conversation through delivery, and stays close after the deal
              or product ships.
            </p>
            <p>
              1. Start a conversation &mdash; 2. Strategic assessment &mdash;
              3. Engagement &amp; execution &mdash; 4. Ongoing partnership.
            </p>
          </div>
          <div
            className="how-photo"
            style={{ backgroundImage: `url(${howItWorksImage})` }}
          />
        </div>
      </section>

      <section className="section enquire" id="enquire">
        <div className="container enquire-inner">
          <h2>Let&apos;s build the Future Together.</h2>
          <p>Whatever stage you&apos;re at, our team is a good place to start.</p>

          <div className="grid grid-3 enquire-cards">
            {enquireHighlights.map((item) => (
              <div className="card" key={item.title}>
                <div
                  className="enquire-card-bg"
                  style={{ backgroundImage: `url(${ctaBgImage})` }}
                />
                <h3>{item.title}</h3>
                <p>{item.desc}</p>
              </div>
            ))}
          </div>

          <div className="enquire-actions">
            <Link to="/contact-us" className="btn btn-primary">
              Start a Conversation
            </Link>
          </div>
        </div>
      </section>
    </>
  );
}

export default Home;
